<template>
    <div class="settings">
        <a class="create-order__backward" @click="router.go(-1)">Назад</a>
        <h2 class="settings__main-title">Смена пароля</h2>
        <div class="settings__change-password">
            <input-component class="settings__input" v-model:meaning="passwordForm.password" @input="errorsPassword.password = ''" inputType="password" inputName="oldPassword" inputLabel="Введите текущий пароль" inputContent="********" :inputError="errorsPassword.password" :show-pass="true"/>
            <input-component class="settings__input" v-model:meaning="passwordForm.newPassword" @input="errorsPassword.newPassword = ''" inputType="password" inputName="Newpassword" inputLabel="Введите новый пароль" inputContent="********" :inputError="errorsPassword.newPassword" :show-pass="true"/>
            <input-component class="settings__input" v-model:meaning="confirmedPassword" inputType="password" inputName="confirmedPassword" inputLabel="Повторите новый пароль" inputContent="********" :inputError="confirmed" :show-pass="true"/>
            <button-component class="settings__submit" :class="{ settings__submit_disabled: disabled }" buttonText="Сменить пароль" :disabled="disabled" @click.prevent="updatePassword"/>
        </div>
    </div>
</template>
<script setup lang="ts">
import router from '../app/router/router'
import buttonComponent from '../shared/buttonComponent.vue'
import InputComponent from '../shared/Form/Input/InputComponent.vue'
import axios from '../app/lib/api'
import { ref, watch } from 'vue'
import { updatePasswordShema } from '../app/lib/shemas/updateUserShema'
import toast from '../app/lib/hooks/errorToast'
import { useLoadingStore } from '../app/store/store'

const loading = useLoadingStore()
const openPasswordPopup = ref(false)
const openLoginPopup = ref(false)
const confirmed = ref("")
const disabled = ref(true)
const passwordForm = ref({
    password: "",
    newPassword: "",
})
const errorsPassword= ref({
    password: "",
    newPassword: "",
})
const confirmedPassword = ref("")
const emailForm = ref({
    email: "",
    password: "",
})
const errorsEmail = ref({
    email: "",
    password: "",
})

async function logout() {
    try {
        await axios.auth.logout()
        document.cookie = "access_token=;max-age=-1;path=/";
        localStorage.removeItem("roles")
        router.push({name: 'login'})
    } catch (error) {
    }
}

async function updatePassword() {
    try {
        await updatePasswordShema.validate(passwordForm.value, { abortEarly: false })
        errorsPassword.value = {
            password: "",
            newPassword: "",
        }
        try {
            loading.loading()
            const res = await axios.auth.updatePassword(passwordForm.value)
            loading.load()
            toast("success", res.data.message)
        } catch (error: any) {
            loading.load()
            toast("error", error.response.data.message)
            error.response.data.errors?.forEach((item: any) => toast("error", item.message))
        }
    } catch (error: any) {
        // @ts-ignore
        error.inner.forEach((error) => {
            // @ts-ignore
            errorsPassword.value[error.path] = error.message;
        });
    }
}

watch(() => [confirmedPassword.value, passwordForm.value.newPassword], () => {
    if(confirmedPassword.value === passwordForm.value.newPassword) {
        confirmed.value = ""
        disabled.value = false
    } else {
        confirmed.value = "Пароли должны совпадать"
        disabled.value = true
    }
})
</script>